import { useInfiniteQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { listingRequestKeys } from './listingRequestQueryKeys'
import { getListingRequests } from './listingRequestEndpoints'
import { parseListingRequestList } from './listingRequestParser'
import { LISTINGS_PAGE_LIMIT } from '../constants/listingRequestLifecycle'

// Paginated list of the seller's requests. Accumulates pages via useInfiniteQuery
// (card list + "Load more"). `statuses` is reactive so switching the filter
// refetches under a new key; per-filter results stay cached.
export function useListingRequestsQuery(statuses: MaybeRefOrGetter<string[]> = []) {
  return useInfiniteQuery({
    queryKey: () => listingRequestKeys.list({ statuses: toValue(statuses) }),
    queryFn: ({ pageParam }) =>
      getListingRequests({
        page: pageParam,
        limit: LISTINGS_PAGE_LIMIT,
        statuses: toValue(statuses),
      }).then(parseListingRequestList),
    initialPageParam: 1,
    getNextPageParam: (lastPage, allPages) =>
      allPages.length < lastPage.pagination.totalPages ? allPages.length + 1 : undefined,
  })
}
